import { useMutation, useQueryClient } from 'react-query';
import { deleteInventoryReport } from 'api/reports';
import { useToast } from '@chakra-ui/react';

export const useDeleteReportMutation = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(deleteInventoryReport, {
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Report Deleted',
        isClosable: true,
        duration: 3000,
      });

      queryClient.invalidateQueries({
        queryKey: ['fetch-reports'],
      });

      queryClient.invalidateQueries({
        queryKey: ['fetch-impact-reports'],
      });

      queryClient.invalidateQueries({
        queryKey: 'fetch-inventory-reports',
      });

      // Invalidate all activity history queries since reports are deleted
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey;
          return (
            Array.isArray(queryKey) &&
            queryKey.length > 0 &&
            queryKey[0].includes('fetch-report-activity-history')
          );
        },
      });
    },
  });
};
